<template>
  <el-dialog :title="$t('langcfg.txtprint')" :visible.sync="visible" width="60%" top="2vh">
    <div>
      <PViewer :printUrl="printUrl" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="savePDF">{{ $t("langcfg.txtPrintToPDF") }}</el-button>
      <el-button type="primary" @click="printPDF">{{ $t("langcfg.txtPrint") }}</el-button>
      <el-button type="primary" @click="hideDialog('OK')">{{ $t("langcfg.txtCancel") }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { isTrue } from "../../../shared/utils";
import fileSys from "../../../fileoprators/fileSystem";
import PViewer from "../../components/PViewer";
export default {
  name: "PrintViewer",
  data() {
    return {
      order: 8,
      diameter: 4,
      formLabelWidth: "100px",
      index: 0
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    printUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.isVisible;
      },
      set: function (val) {
        this.$emit("update:isVisible", val);
      }
    }
  },
  components: {
    PViewer
  },
  methods: {
    hideDialog(state) {
      this.visible = false;
    },
    savePDF() {
      global.dialog.showSaveDialog(
        {
          title: "PDF",
          filters: [
            {
              name: "PDF",
              extensions: ["pdf"]
            }
          ]
        },
        (filename) => {
          if (filename && filename.length > 0) {
            let result = fileSys.copyFile(fileSys.getCfgPath("ct.pdf"), filename);
            let title = isTrue(result)
              ? this.$t("langcfg.txtSuccess")
              : this.$t("langcfg.txtError");
            let message = isTrue(result)
              ? this.$t("langcfg.txtSavePDFSuccess")
              : this.$t("langcfg.txtSavePDFFailed");
            let type = isTrue(result) ? "success" : "error";
            this.$notify({
              title: title,
              message: message,
              showClose: true,
              type: type,
              duration: 3000
            });
          }
        }
      );
    },
    printPDF() {}
  }
};
</script>
<style scoped>
.el-dialog /deep/ .el-dialog__body {
  padding: 10px;
}
.el-button {
  width: 200px;
  border: 1px solid gray;
}
</style>



// WEBPACK FOOTER //
// src/topography/pages/dialog-forms/PrintViewer.vue